/* ═══════════════════════════════════════════════════════════════════════════
   ΣΥΝΟΨΗ ΠΛΗΡΩΜΩΝ — ΜΙΑ ΔΙΑΤΥΠΩΣΗ ΓΙΑ ΟΛΕΣ ΤΙΣ ΟΘΟΝΕΣ
   ---------------------------------------------------------------------------
   Τα ΝΟΥΜΕΡΑ βγαίνουν αποκλειστικά από το `yms_pay_summary` του server
   (total_cents · paid_cents · balance_cents · extras_paid_cents ·
   pack_paid_cents · deposit_row). Εδώ ζει μόνο το ΠΩΣ ΛΕΓΟΝΤΑΙ — ώστε η
   καρτέλα, το παράθυρο συνδέσμου, το /pay και το email να μη γράφουν το καθένα
   τη δική του φράση για την ίδια κατάσταση εγγύησης.

   ΚΑΜΙΑ ΑΡΙΘΜΗΤΙΚΗ ΕΔΩ: ούτε ένα +, ούτε ένα ποσοστό. Αν κάποια οθόνη χρειαστεί
   νέο νούμερο, μπαίνει στο yms_pay_summary — όχι σε αυτό το αρχείο.
   ═══════════════════════════════════════════════════════════════════════════ */

import { formatMoneyEU } from './format';

export type DepositRowLike = {
  status?: string;
  amount_cents?: number;
  captured_cents?: number;
  refunded_cents?: number;
} | null | undefined;

export type DepositPhrase = { text: string; color: string; kind: string } | null;

const W: Record<string, Record<string, string>> = {
  el: { held:'δεσμευμένη', charged:'χρεωμένη', released:'αποδεσμευμένη', refunded:'επιστράφηκε' },
  en: { held:'on hold',    charged:'charged',  released:'released',      refunded:'refunded' },
};

/** Η κατάσταση της εγγύησης σε μία φράση: «δεσμευμένη 4.000,00 €». */
export function depositPhrase(row: DepositRowLike, lang = 'el'): DepositPhrase {
  if (!row || !row.status) return null;
  const w = W[lang] || W.en;
  const eur = (c: number | undefined) => formatMoneyEU((c || 0) / 100);
  switch (row.status) {
    case 'authorised':
      return { kind:'held',     color:'var(--option)',  text:`${w.held} ${eur(row.amount_cents)}` };
    case 'captured':
    case 'paid':
      return { kind:'charged',  color:'var(--confirm)', text:`${w.charged} ${eur(row.captured_cents || row.amount_cents)}` };
    case 'released':
      return { kind:'released', color:'var(--faint)',   text:`${w.released} ${eur(row.amount_cents)}` };
    case 'refunded':
      return { kind:'refunded', color:'var(--faint)',   text:`${w.refunded} ${eur(row.refunded_cents || row.amount_cents)}` };
    default:
      return null;
  }
}
